import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getLanguagePref } from './utilities/language'
import commonEN from './i18n/en/common.json'
import commonCN from './i18n/cn/common.json'
import userManagementCN from './i18n/cn/userManagement.json'
import userManagementEN from './i18n/en/userManagement.json'
import billingManagement from './i18n/en/billingManagement.json'

const resources = {
  en: {
    common: commonEN,
    userManagement: userManagementEN,
    billingManagement: billingManagement
  },
  cn: {
    common: commonCN,
    userManagement: userManagementCN,
    billingManagement: billingManagement
  }
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  lng: getLanguagePref(),
  interpolation: {
    escapeValue: false // react already safes from xss
  }
})

export default i18n
